import api from '../api'

export default {
  updateAllCheckBoxes (context, data) {
    context.commit('updatePageState', Object.assign({}, context.state.pageListReport, {
      allCheckboxes: data
    }))
  },
  updateCheckBoxes (context, data) {
    context.commit('updatePageState', Object.assign({}, context.state.pageListReport, {
      checkboxes: data
    }))
  },
  updateIsCheckAll (context, data) {
    if (data === true) {
      context.commit('updatePageState', Object.assign({}, context.state.pageListReport, {
        isCheckAll: data,
        checkboxes: context.state.pageListReport.allCheckboxes
      }))
    } else {
      context.commit('updatePageState', Object.assign({}, context.state.pageListReport, {
        isCheckAll: data,
        checkboxes: []
      }))
    }
  },
  resetAll (context) {
    context.commit('updatePageState', Object.assign({}, context.state.pageListReport, {
      isCheckAll: false,
      checkboxes: [],
      allCheckboxes: []
    }))
  },
  async loadList (context) {
    let response = await api.report.list()

    context.commit('listCommit', response)

    return response
  },
  async loadDetailReport (context, reportId) {
    let response = await api.report.detail(reportId)

    context.commit('pageDetailCommit', Object.assign({}, context.state.detailReport, {
      selected_report_id: reportId,
      payments: response.payments,
      detail_report: response.report,
      summary_report: response.summary,
      summary_success_report: response.summary_success,
      report_total_usd: response.summary.all.usd,
      report_total_vnd: response.summary.all.vnd,
      summary_total_usd: response.summary_success.all.usd,
      summary_total_vnd: response.summary_success.all.vnd,
      payment_total_vnd: response.summary_success.payment.vnd,
      payment_total_usd: response.summary_success.payment.usd
    }))

    return response
  },
  resetDetailReport (context) {
    context.commit('pageDetailCommit', {
      payments: [],
      selected_report_id: null,
      detail_report: null,
      summary_report: null,
      summary_success_report: null,
      report_total_usd: 0,
      report_total_vnd: 0,
      summary_total_usd: 0,
      summary_total_vnd: 0,
      payment_total_vnd: 0,
      payment_total_usd: 0
    })
  },
  updateDetailReport (context, detail) {
    context.commit('pageDetailCommit', Object.assign({}, context.state.detailReport, detail))
  },
  updateSelectedAccount (context, selectedAccount) {
    context.commit('updateAutoReportSelectedAccount', selectedAccount)
  }
}
